export default __webpack_public_path__ + "static/media/bathtubIcon.b95c8ddb.svg";